export default function (context) {
    context.commit('clean');
    context.commit('form/clean');
}